import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './ThreadOrderSelect';
import { getThreadState } from '../../selectors';
import { changeOrder } from '../../actionCreators';

export type StateProps = Pick<Props, 'order' | 'streamId'>;
export type DispatchProps = Pick<Props, 'onOrderChangedDefault'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  { commentableItemId, commentableTypeId, parentId }
) => {
  const { streamId, order } = getThreadState(
    state,
    commentableTypeId,
    commentableItemId,
    parentId
  );

  return {
    streamId,
    order,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onOrderChangedDefault: changeOrder,
};

export default connect(mapStateToProps, mapDispatchToProps);
